"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: { display: 'flex', paddingTop: 12, justifyContent: 'flex-end' },
    buttons: {
        display: 'grid',
        gridColumnGap: 8,
        gridTemplateColumns: 'min-content min-content',
    },
}));
